import React from "react"
import { Image, StyleSheet, View } from "react-native"
import { List } from "react-native-paper"
import FontAwesome5 from "react-native-vector-icons/FontAwesome5"
import TextM from "../../common/components/text/TextM"
import FilledButtonM from "../../common/components/button/FilledButtonM"
import { ModalSkeleton } from "../../common/modals/ModalSkeleton"
import { theme } from "../../common/theme/theme"
import logo from "@assets/logo-blue.png"

/**
 * « Les avantages des cours Masteur » — la modale d'explication du co-cours,
 * ouverte depuis le (i) de la section « Mode de cours ».
 *
 * Extraite de ChangePlanBottomModal pour être montée à l'identique par le
 * funnel d'inscription : le parent doit lire le même argumentaire, qu'il passe
 * par le lien commercial ou par le funnel. Une deuxième rédaction dériverait au
 * premier ajustement de discours.
 */

export const SHARED_COURSE_ADVANTAGES = [
    {
        icon: "brain",
        title: "Une méthode pour assimiler 2× plus vite",
        description:
            "L'enfant alterne les moments où il cherche par lui-même et les explications du professeur, pour mieux retenir et progresser plus vite.",
    },
    {
        icon: "piggy-bank",
        title: "Un prix par heure 2× plus avantageux",
        description:
            "Le temps du professeur est partagé entre deux élèves, sans attente ni pause inutile : tout le monde apprend, tout le temps.",
    },
    {
        icon: "magic",
        title: "Des exercices ultra-personnalisés, 2× plus motivants",
        description:
            "Chaque séance s'adapte aux besoins et aux centres d'intérêt de l'élève, pour rendre l'apprentissage plus efficace et agréable.",
    },
    {
        icon: "laptop",
        title: "Un cours à distance aussi efficace que le présentiel",
        description:
            "L'app permet des échanges en direct (photos, corrections instantanées) et suit la concentration et les progrès après chaque séance.",
    },
]

export const SharedCourseAdvantagesModal = ({ isVisible, onClose }) => (
    <ModalSkeleton isVisible={isVisible} onClose={onClose}>
        <View style={{ padding: 20, gap: 16 }}>
            <View style={styles.titleRow}>
                <TextM fontWeight="Bold" fontSize={16}>
                    Les avantages des cours
                </TextM>
                <Image
                    source={logo}
                    style={{ width: 90, height: 30 }}
                    resizeMode="contain"
                />
            </View>
            <List.AccordionGroup>
                {SHARED_COURSE_ADVANTAGES.map((item, index) => (
                    <List.Accordion
                        key={index}
                        id={index.toString()}
                        title={item.title}
                        titleNumberOfLines={3}
                        titleStyle={styles.accordionTitle}
                        left={() => (
                            <View style={styles.advantageIconContainer}>
                                <FontAwesome5
                                    name={item.icon}
                                    size={16}
                                    color={theme.colors.primary}
                                    solid
                                />
                            </View>
                        )}
                        style={styles.accordionItem}
                        contentStyle={{ paddingRight: 8 }}
                    >
                        <View style={styles.accordionContent}>
                            <TextM color={theme.colors.grey} fontSize={13} wrap>
                                {item.description}
                            </TextM>
                        </View>
                    </List.Accordion>
                ))}
            </List.AccordionGroup>
            <FilledButtonM
                label="Compris"
                onPress={onClose}
                style={{ width: "100%", marginTop: 8 }}
            />
        </View>
    </ModalSkeleton>
)

const styles = StyleSheet.create({
    titleRow: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        gap: 6,
        flexWrap: "wrap",
    },
    accordionTitle: {
        fontFamily: "Montserrat-SemiBold",
        fontSize: 13,
        color: theme.colors.primary,
        flexShrink: 1,
    },
    advantageIconContainer: {
        width: 32,
        height: 32,
        borderRadius: 16,
        backgroundColor: theme.colors.material.primary["50"],
        justifyContent: "center",
        alignItems: "center",
        marginLeft: 4,
    },
    accordionItem: {
        backgroundColor: theme.colors.white,
        borderWidth: 1,
        borderColor: theme.colors.lightMore,
        borderRadius: 8,
        marginBottom: 8,
        overflow: "hidden",
        paddingVertical: 4,
    },
    accordionContent: {
        paddingLeft: 12,
        paddingRight: 16,
        paddingBottom: 12,
        paddingTop: 0,
        backgroundColor: theme.colors.white,
    },
})
